import { render, staticRenderFns } from "./CategoriaTarifaListagem.vue?vue&type=template&id=53b1aaea&scoped=true&"
import script from "./CategoriaTarifaListagem.vue?vue&type=script&lang=js&"
export * from "./CategoriaTarifaListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b1aaea",
  null
  
)

export default component.exports